import { render, staticRenderFns } from "./panelEditarBaseFiscal.vue?vue&type=template&id=5c216d7a&"
import script from "./panelEditarBaseFiscal.vue?vue&type=script&lang=js&"
export * from "./panelEditarBaseFiscal.vue?vue&type=script&lang=js&"
import style0 from "./panelEditarBaseFiscal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports